// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".optional_list span[data-v-7f647f2a]{display:inline-block;width:50%;text-align:left;font-size:14px;height:39px;line-height:39px;border-bottom:1px solid #888}.optional_list span.item-left[data-v-7f647f2a]{text-align:left;text-indent:1em}.optional_list span.item-right[data-v-7f647f2a]{text-align:right;width:calc(50% - 1em);padding-right:1em}", ""]);
// Exports
module.exports = exports;
